import { translateBrand } from "@/lib/i18n";
import { BrandMessageIds } from "@nitro-ape/shared/lib/brand-config";
import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_main/dashboard/")({
  head: () => ({
    meta: [
      {
        title: translateBrand(BrandMessageIds.metaTitleDashboard),
      },
    ],
  }),
  component: DashboardPage,
});

function DashboardPage() {
  return <Navigate to="/dashboard/progress" />;
}
